import { f as d } from "./chunk-lit-element-D3OkYgeM.js";
/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */
const m = { PENDING: 1, COMPLETE: 2, ERROR: 3 }, p = Symbol();
class v {
  get taskComplete() {
    return this.t || (this.i === 1 ? this.t = new Promise(((t, i) => {
      this.o = t, this.h = i;
    })) : this.i === 3 ? this.t = Promise.reject(this.l) : this.t = Promise.resolve(this.u)), this.t;
  }
  constructor(t, i, r) {
    var h;
    this.p = 0, this.i = 0, (this._ = t).addController(this);
    const s = typeof i == "object" ? i : { task: i, args: r };
    this.v = s.task, this.j = s.args, this.m = s.argsEqual ?? f, this.k = s.onComplete, this.A = s.onError, this.autoRun = s.autoRun ?? !0, "initialValue" in s && (this.u = s.initialValue, this.i = 2, this.O = (h = this.T) == null ? void 0 : h.call(this));
  }
  hostUpdate() {
    this.autoRun === !0 && this.S();
  }
  hostUpdated() {
    this.autoRun === "afterUpdate" && this.S();
  }
  T() {
    if (this.j === void 0) return;
    const t = this.j();
    if (!Array.isArray(t)) throw Error("The args function must return an array");
    return t;
  }
  async S() {
    const t = this.T(), i = this.O;
    this.O = t, t === i || t === void 0 || i !== void 0 && this.m(i, t) || await this.run(t);
  }
  async run(t) {
    var a, o, n, u, l;
    let i, r;
    t ?? (t = this.T()), this.O = t, this.i === 1 ? (a = this.q) == null || a.abort() : (this.t = void 0, this.o = void 0, this.h = void 0), this.i = 1, this.autoRun === "afterUpdate" ? queueMicrotask((() => this._.requestUpdate())) : this._.requestUpdate();
    const s = ++this.p;
    this.q = new AbortController();
    let h = !1;
    try {
      i = await this.v(t, { signal: this.q.signal });
    } catch (c) {
      h = !0, r = c;
    }
    if (this.p === s) {
      if (i === p) this.i = 0;
      else {
        if (h === !1) {
          try {
            (o = this.k) == null || o.call(this, i);
          } catch {
          }
          this.i = 2, (n = this.o) == null || n.call(this, i);
        } else {
          try {
            (u = this.A) == null || u.call(this, r);
          } catch {
          }
          this.i = 3, (l = this.h) == null || l.call(this, r);
        }
        this.u = i, this.l = r;
      }
      this._.requestUpdate();
    }
  }
  abort(t) {
    var i;
    this.i === 1 && ((i = this.q) == null || i.abort(t));
  }
  get value() {
    return this.u;
  }
  get error() {
    return this.l;
  }
  get status() {
    return this.i;
  }
  render(t) {
    var i, r, s, h;
    switch (this.i) {
      case 0:
        return (i = t.initial) == null ? void 0 : i.call(t);
      case 1:
        return (r = t.pending) == null ? void 0 : r.call(t);
      case 2:
        return (s = t.complete) == null ? void 0 : s.call(t, this.value);
      case 3:
        return (h = t.error) == null ? void 0 : h.call(t, this.error);
      default:
        throw Error("Unexpected status: " + this.i);
    }
  }
}
const f = (e, t) => e === t || e.length === t.length && e.every(((i, r) => !d(i, t[r])));
export {
  v as h,
  p as i,
  m as s
};
